
// import { useState } from "react";
// import { 
//   Box, 
//   Button, 
//   Stepper, 
//   Step, 
//   StepLabel, 
//   Toolbar,
//   Snackbar,
//   Alert,
//   AlertTitle,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   ListItem,
//   ListItemText,
//   Typography,
//   Chip,
//   CircularProgress
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import DownloadIcon from "@mui/icons-material/Download";
// import UploadIcon from "@mui/icons-material/Upload";
// import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
// import CBox from "../../basecomp/newComponents/CBox";
// import CUpload from "../../basecomp/newComponents/CUpload";
// import CLoader from "../../basecomp/newComponents/CLoader";
// import MainPageModel from "../model/MainPageModel";

// const steps = ["Upload File", "Process Data", "Download Results"];

// function Maintenance_planning() {
//   const theme = useTheme();

//   // ------------------- State -------------------
//   const [batchId, setBatchId] = useState(localStorage.getItem("batchId") || null);
//   const [activeStep, setActiveStep] = useState(() => {
//     const savedStep = localStorage.getItem("activeStep");
//     return savedStep ? parseInt(savedStep) : 0;
//   });
//   const [fileSelected, setFileSelected] = useState(!!localStorage.getItem("batchId"));
//   const [uploadKey, setUploadKey] = useState(0);
  
//   // Separate loading states for each action
//   const [uploadingFile, setUploadingFile] = useState(false);
//   const [downloadingSample, setDownloadingSample] = useState(false);
//   const [processing, setProcessing] = useState(false);
//   const [downloadingFile, setDownloadingFile] = useState(false);
  
//   // Progress tracking
//   const [progress, setProgress] = useState(0);

//   // Error handling states
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info"
//   });
  
//   const [errorDialog, setErrorDialog] = useState({
//     open: false,
//     title: "",
//     message: "",
//     details: null,
//     errorType: "",
//     helpText: ""
//   });

//   const {
//     handleDownloadSample,
//     handleUploadFile,
//     handleStartProcess,
//     handleDownloadFile
//   } = MainPageModel;

//   // ------------------- Helper Functions -------------------
//   const showSnackbar = (message, severity = "info") => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const closeSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };
  
//   // Simulate progress for operations without real progress tracking
//   const simulateProgress = (duration = 3000) => {
//     setProgress(0);
//     const increment = 100 / (duration / 100);
//     const interval = setInterval(() => {
//       setProgress((prev) => {
//         if (prev >= 95) {
//           clearInterval(interval);
//           return 95; // Stop at 95% until operation completes
//         }
//         return Math.min(prev + increment, 95);
//       });
//     }, 100);
//     return interval;
//   };

//   const showErrorDialog = (error) => {
//     const errorData = error.response?.data;
    
//     if (errorData && errorData.status === "error") {
//       setErrorDialog({
//         open: true,
//         title: errorData.message || "Operation Failed",
//         message: errorData.help || "Please try again.",
//         details: errorData.details,
//         errorType: errorData.error_type || "error",
//         helpText: errorData.help
//       });
//     } else {
//       setErrorDialog({
//         open: true,
//         title: "Operation Failed",
//         message: error.message || "An unexpected error occurred.",
//         details: null,
//         errorType: "error",
//         helpText: "If the problem persists, please contact support."
//       });
//     }
//   };

//   const closeErrorDialog = () => {
//     setErrorDialog({ ...errorDialog, open: false });
//   };

//   // ------------------- File Upload -------------------
//   const onFileUpload = async (fileInputOrList) => {
//     setUploadKey(prev => prev + 1);

//     const fileList = fileInputOrList.target?.files || fileInputOrList;

//     if (!fileList || fileList.length === 0) {
//       showSnackbar("Please select a file to upload", "warning");
//       return;
//     }

//     const file = fileList[0];
    
//     // Client-side validation
//     const validExtensions = [".xlsx", ".xls"];
//     const fileExt = "." + file.name.toLowerCase().split(".").pop();
    
//     if (!validExtensions.includes(fileExt)) {
//       showErrorDialog({
//         response: {
//           data: {
//             status: "error",
//             message: "Invalid File Format",
//             help: `The file "${file.name}" is not a valid format. Please upload an Excel (.xlsx, .xls) or CSV (.csv) file.`,
//             details: {
//               uploaded_format: fileExt,
//               allowed_formats: validExtensions,
//               your_file: file.name
//             },
//             error_type: "invalid_format"
//           }
//         }
//       });
//       return;
//     }

//     // Check file size (max 10MB)
//     const maxSize = 10 * 1024 * 1024;
//     if (file.size > maxSize) {
//       showErrorDialog({
//         response: {
//           data: {
//             status: "error",
//             message: "File Too Large",
//             help: "Please upload a file smaller than 10MB",
//             details: {
//               file_size: `${(file.size / (1024 * 1024)).toFixed(2)} MB`,
//               max_size: "10 MB"
//             },
//             error_type: "file_too_large"
//           }
//         }
//       });
//       return;
//     }

//     setUploadingFile(true);
//     showSnackbar("Uploading file...", "info");
    
//     // Start progress simulation
//     const progressInterval = simulateProgress(2000);

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       const response = await handleUploadFile(formData);
//       const { batch_id, rows_inserted } = response;

//       // Complete progress
//       clearInterval(progressInterval);
//       setProgress(100);

//       setBatchId(batch_id);
//       localStorage.setItem("batchId", batch_id);
//       setFileSelected(true);
//       setActiveStep(1);

//       showSnackbar(
//         `File uploaded successfully! ${rows_inserted} rows inserted.`,
//         "success"
//       );
//     } catch (error) {
//       console.error("Upload failed:", error);
//       clearInterval(progressInterval);
//       setProgress(0);
//       showErrorDialog(error);
//       setFileSelected(false);
//     } finally {
//       setUploadingFile(false);
//       setTimeout(() => setProgress(0), 500);
//     }
//   };

//   // ------------------- Start Process -------------------
//   const onStartProcess = async () => {
//     if (!batchId) {
//       showSnackbar("Batch ID missing. Please upload a file first.", "warning");
//       return;
//     }

//     setProcessing(true);
//     showSnackbar("Processing data...", "info");
    
//     // Start progress simulation
//     const progressInterval = simulateProgress(4000);

//     try {
//       const response = await handleStartProcess(batchId);
      
//       // Complete progress
//       clearInterval(progressInterval);
//       setProgress(100);
      
//       localStorage.setItem("activeStep", "2");
//       setActiveStep(2);
//       showSnackbar(
//         `Data processed successfully! ${response.rows_processed} records processed.`,
//         "success"
//       );
//     } catch (error) {
//       console.error("Process failed:", error);
//       clearInterval(progressInterval);
//       setProgress(0);
//       showErrorDialog(error);
//     } finally {
//       setProcessing(false);
//       setTimeout(() => setProgress(0), 500);
//     }
//   };

//   // ------------------- Download Processed File -------------------
//   const onDownloadFile = async () => {
//     setUploadKey(prev => prev + 1);

//     if (!batchId) {
//       showSnackbar("Batch ID missing. Please upload and process a file first.", "warning");
//       return;
//     }

//     setDownloadingFile(true);
//     showSnackbar("Downloading file...", "info");
    
//     // Start progress simulation
//     const progressInterval = simulateProgress(2000);

//     try {
//       await handleDownloadFile(batchId);

//       // Complete progress
//       clearInterval(progressInterval);
//       setProgress(100);

//       // Cleanup after download
//       localStorage.removeItem("batchId");
//       localStorage.removeItem("activeStep");
//       setBatchId(null);
//       setFileSelected(false);
//       setActiveStep(0);

//       showSnackbar("File downloaded successfully!", "success");
//     } catch (error) {
//       console.error("Download failed:", error);
//       clearInterval(progressInterval);
//       setProgress(0);
//       showErrorDialog(error);
//     } finally {
//       setDownloadingFile(false);
//       setTimeout(() => setProgress(0), 500);
//     }
//   };

//   // ------------------- Download Sample -------------------
//   const onDownloadSample = async () => {
//     setDownloadingSample(true);
    
//     // Start progress simulation
//     const progressInterval = simulateProgress(1500);
    
//     try {
//       await handleDownloadSample();
      
//       // Complete progress
//       clearInterval(progressInterval);
//       setProgress(100);
      
//       showSnackbar("Sample file downloaded!", "success");
//     } catch (error) {
//       clearInterval(progressInterval);
//       setProgress(0);
//       showSnackbar("Failed to download sample file", "error");
//     } finally {
//       setDownloadingSample(false);
//       setTimeout(() => setProgress(0), 500);
//     }
//   };

//   // Check if any operation is in progress
//   const isAnyOperationInProgress = uploadingFile || downloadingSample || processing || downloadingFile;

//   // Get current operation status for CLoader
//   const getLoaderStatus = () => {
//     if (uploadingFile || downloadingSample || downloadingFile) return "Uploading";
//     if (processing) return "Processing";
//     return "Processing";
//   };

//   return (
//     <>
//       <Toolbar />

//       {/* CLoader overlay - shows when any operation is in progress */}
//       {isAnyOperationInProgress && (
//         <CLoader 
//           progress={progress}
//           stats={{
//             processed: 0,
//             total: 0,
//             timeElapsed: "0:00",
//             timeRemaining: "0:00"
//           }}
//           status={getLoaderStatus()}
//           hideTimeRemaining={uploadingFile || downloadingSample || downloadingFile}
//           theme={theme}
//         />
//       )}

//       <Box sx={{ maxWidth: 1100, mx: "auto", mt: 4 }}>
//         {/* Stepper */}
//         <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
//           {steps.map((label) => (
//             <Step key={label}>
//               <StepLabel>{label}</StepLabel>
//             </Step>
//           ))}
//         </Stepper>

//         <CBox sx={{ p: 3, borderRadius: 2, boxShadow: 2 }}>
//           {/* Upload Area */}
//           <Box
//             sx={{
//               border: "2px dashed",
//               borderColor: theme.palette.primary.main,
//               borderRadius: 2,
//               p: 4,
//               textAlign: "center",
//               mb: 3,
//               position: "relative"
//             }}
//           >
//             <CUpload 
//               key={uploadKey} 
//               modelSelected={true} 
//               onFileSelection={onFileUpload} 
//               theme={theme}
//               disabled={isAnyOperationInProgress}
//             />
//             <Typography variant="caption" color="textSecondary" sx={{ mt: 2, display: "block" }}>
//               Supported formats: .xlsx, .xls (Max 10MB)
//             </Typography>
//           </Box>

//           {/* Action Buttons */}
//           <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
//             <Button
//               variant="contained"
//               startIcon={downloadingSample ? <CircularProgress size={20} /> : <DownloadIcon />}
//               onClick={onDownloadSample}
//               disabled={downloadingSample || activeStep >= 1 || isAnyOperationInProgress}
//             >
//               Download Sample
//             </Button>

//             <Button
//               variant="contained"
//               startIcon={processing ? <CircularProgress size={20} /> : <UploadIcon />}
//               disabled={!fileSelected || activeStep !== 1 || isAnyOperationInProgress}
//               onClick={onStartProcess}
//             >
//               Start Process
//             </Button>

//             <Button
//               variant="contained"
//               startIcon={downloadingFile ? <CircularProgress size={20} /> : <DownloadIcon />}
//               disabled={!fileSelected || activeStep !== 2 || isAnyOperationInProgress}
//               onClick={onDownloadFile}
//             >
//               Download File
//             </Button>
//           </Box>
//         </CBox>
//       </Box>

//       {/* Snackbar for quick notifications */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={closeSnackbar}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={closeSnackbar}
//           severity={snackbar.severity}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//       {/* Error Dialog */}
//       <Dialog
//         open={errorDialog.open}
//         onClose={closeErrorDialog}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           <ErrorOutlineIcon color="error" />
//           {errorDialog.title}
//         </DialogTitle>
        
//         <DialogContent>
//           <Alert severity="error" sx={{ mb: 2 }}>
//             {errorDialog.message}
//           </Alert>

//           {errorDialog.details && (
//             <Box sx={{ mt: 2 }}>
//               <Typography variant="subtitle2" gutterBottom>
//                 Details:
//               </Typography>
              
//               {/* Invalid format */}
//               {errorDialog.errorType === "invalid_format" && (
//                 <Box sx={{ mb: 2 }}>
//                   <Typography variant="body2" color="textSecondary">
//                     <strong>Your file:</strong> {errorDialog.details.your_file}
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary">
//                     <strong>Format:</strong> {errorDialog.details.uploaded_format}
//                   </Typography>
//                   <Box sx={{ mt: 1 }}>
//                     <Typography variant="body2" color="textSecondary" gutterBottom>
//                       <strong>Allowed formats:</strong>
//                     </Typography>
//                     <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//                       {errorDialog.details.allowed_formats?.map((format) => (
//                         <Chip 
//                           key={format} 
//                           label={format} 
//                           size="small" 
//                           color="primary" 
//                           variant="outlined" 
//                         />
//                       ))}
//                     </Box>
//                   </Box>
//                 </Box>
//               )}

//               {/* Missing columns */}
//               {errorDialog.errorType === "missing_columns" && (
//                 <Box sx={{ mb: 2 }}>
//                   <Typography variant="body2" color="error" gutterBottom>
//                     <strong>Missing columns:</strong>
//                   </Typography>
//                   <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
//                     {errorDialog.details.missing_columns?.map((col) => (
//                       <Chip 
//                         key={col} 
//                         label={col} 
//                         size="small" 
//                         color="error" 
//                       />
//                     ))}
//                   </Box>
//                 </Box>
//               )}

//               {/* Validation errors */}
//               {errorDialog.errorType === "validation_errors" && (
//                 <Box sx={{ mb: 2 }}>
//                   <Alert severity="warning" sx={{ mb: 1 }}>
//                     Found {errorDialog.details.total_errors} error(s) in {errorDialog.details.total_rows} rows
//                   </Alert>
//                   <List dense sx={{ maxHeight: 300, overflow: "auto", bgcolor: "grey.50", p: 1, borderRadius: 1 }}>
//                     {errorDialog.details.errors?.map((error, idx) => (
//                       <ListItem key={idx} sx={{ py: 0.5 }}>
//                         <ListItemText
//                           primary={error}
//                           primaryTypographyProps={{ 
//                             variant: "body2", 
//                             color: "error",
//                             fontFamily: "monospace"
//                           }}
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                   {errorDialog.details.remaining_errors > 0 && (
//                     <Typography 
//                       variant="body2" 
//                       color="textSecondary" 
//                       sx={{ mt: 1, fontStyle: "italic" }}
//                     >
//                       ... and {errorDialog.details.remaining_errors} more error(s)
//                     </Typography>
//                   )}
//                 </Box>
//               )}

//               {/* File too large */}
//               {errorDialog.errorType === "file_too_large" && (
//                 <Box sx={{ mb: 2 }}>
//                   <Typography variant="body2" color="textSecondary">
//                     <strong>File size:</strong> {errorDialog.details.file_size}
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary">
//                     <strong>Maximum allowed:</strong> {errorDialog.details.max_size}
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           )}

//           {/* Help section */}
//           <Alert severity="info" sx={{ mt: 2 }}>
//             <AlertTitle>Need Help?</AlertTitle>
//             Download the sample file to see the correct format and required columns.
//           </Alert>
//         </DialogContent>

//         <DialogActions>
//           <Button
//             onClick={onDownloadSample}
//             startIcon={<DownloadIcon />}
//             variant="outlined"
//           >
//             Download Sample
//           </Button>
//           <Button onClick={closeErrorDialog} variant="contained">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }

// export default Maintenance_planning;

import { useState } from "react";
import { 
  Box, 
  Button, 
  Stepper, 
  Step, 
  StepLabel, 
  Toolbar,
  Snackbar,
  Alert,
  AlertTitle,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Typography,
  Chip,
  CircularProgress
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CBox from "../../basecomp/newComponents/CBox";
import CUpload from "../../basecomp/newComponents/CUpload";
import CLoader from "../../basecomp/newComponents/CLoader";
import MainPageModel from "../model/MainPageModel";

const steps = ["Upload File", "Process Data", "Download Results"];

function Maintenance_planning() {
  const theme = useTheme();

  // ------------------- State -------------------
  const [batchId, setBatchId] = useState(localStorage.getItem("batchId") || null);
  const [activeStep, setActiveStep] = useState(() => {
    const savedStep = localStorage.getItem("activeStep");
    return savedStep ? parseInt(savedStep) : 0;
  });
  const [fileSelected, setFileSelected] = useState(!!localStorage.getItem("batchId"));
  const [uploadedFileName, setUploadedFileName] = useState(
    localStorage.getItem("uploadedFileName") || null
  );
  const [uploadKey, setUploadKey] = useState(0);
  
  // Separate loading states for each action
  const [uploadingFile, setUploadingFile] = useState(false);
  const [downloadingSample, setDownloadingSample] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [downloadingFile, setDownloadingFile] = useState(false);
  
  // Progress tracking
  const [progress, setProgress] = useState(0);

  // Error handling states
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info"
  });
  
  const [errorDialog, setErrorDialog] = useState({
    open: false,
    title: "",
    message: "",
    details: null,
    errorType: "",
    helpText: ""
  });

  // Confirmation dialogs
  const [confirmReset, setConfirmReset] = useState(false);

  const {
    handleDownloadSample,
    handleUploadFile,
    handleStartProcess,
    handleDownloadFile
  } = MainPageModel;

  // ------------------- Helper Functions -------------------
  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  
  // Simulate progress for operations without real progress tracking
  const simulateProgress = (duration = 3000) => {
    setProgress(0);
    const increment = 100 / (duration / 100);
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 95) {
          clearInterval(interval);
          return 95; // Stop at 95% until operation completes
        }
        return Math.min(prev + increment, 95);
      });
    }, 100);
    return interval;
  };

  const showErrorDialog = (error) => {
    const errorData = error.response?.data;
    
    if (errorData && errorData.status === "error") {
      setErrorDialog({
        open: true,
        title: errorData.message || "Operation Failed",
        message: errorData.help || "Please try again.",
        details: errorData.details,
        errorType: errorData.error_type || "error",
        helpText: errorData.help
      });
    } else {
      setErrorDialog({
        open: true,
        title: "Operation Failed",
        message: error.message || "An unexpected error occurred.",
        details: null,
        errorType: "error",
        helpText: "If the problem persists, please contact support."
      });
    }
  };

  const closeErrorDialog = () => {
    setErrorDialog({ ...errorDialog, open: false });
  };

  // ------------------- Reset Function -------------------
  const onReset = () => {
    localStorage.removeItem("batchId");
    localStorage.removeItem("activeStep");
    localStorage.removeItem("uploadedFileName");
    setBatchId(null);
    setFileSelected(false);
    setActiveStep(0);
    setUploadedFileName(null);
    setUploadKey(prev => prev + 1);
    setConfirmReset(false);
    showSnackbar("Reset complete. You can upload a new file.", "info");
  };

  // ------------------- File Upload -------------------
  const onFileUpload = async (fileInputOrList) => {
    setUploadKey(prev => prev + 1);

    const fileList = fileInputOrList.target?.files || fileInputOrList;

    if (!fileList || fileList.length === 0) {
      showSnackbar("Please select a file to upload", "warning");
      return;
    }

    const file = fileList[0];
    
    // Client-side validation
    const validExtensions = [".xlsx", ".xls"];
    const fileExt = "." + file.name.toLowerCase().split(".").pop();
    
    if (!validExtensions.includes(fileExt)) {
      showErrorDialog({
        response: {
          data: {
            status: "error",
            message: "Invalid File Format",
            help: `The file "${file.name}" is not a valid format. Please upload an Excel (.xlsx, .xls) file.`,
            details: {
              uploaded_format: fileExt,
              allowed_formats: validExtensions,
              your_file: file.name
            },
            error_type: "invalid_format"
          }
        }
      });
      return;
    }

    // Check file size (max 10MB)
    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      showErrorDialog({
        response: {
          data: {
            status: "error",
            message: "File Too Large",
            help: "Please upload a file smaller than 10MB",
            details: {
              file_size: `${(file.size / (1024 * 1024)).toFixed(2)} MB`,
              max_size: "10 MB"
            },
            error_type: "file_too_large"
          }
        }
      });
      return;
    }

    setUploadingFile(true);
    showSnackbar("Uploading file...", "info");
    
    // Start progress simulation
    const progressInterval = simulateProgress(2000);

    // 🚨 CHANGED: Pass the file directly, not FormData
    try {
      const response = await handleUploadFile(file);
      const { batch_id, rows_inserted } = response;

      // Complete progress
      clearInterval(progressInterval);
      setProgress(100);

      setBatchId(batch_id);
      setUploadedFileName(file.name);
      localStorage.setItem("batchId", batch_id);
      localStorage.setItem("uploadedFileName", file.name);
      localStorage.setItem("activeStep", "1");
      setFileSelected(true);
      setActiveStep(1);

      showSnackbar(
        `File uploaded successfully! ${rows_inserted} rows inserted.`,
        "success"
      );
    } catch (error) {
      console.error("Upload failed:", error);
      clearInterval(progressInterval);
      setProgress(0);
      showErrorDialog(error);
      setFileSelected(false);
    } finally {
      setUploadingFile(false);
      setTimeout(() => setProgress(0), 500);
    }
  };

  // ------------------- Start Process -------------------
  const onStartProcess = async () => {
    if (!batchId) {
      showSnackbar("Batch ID missing. Please upload a file first.", "warning");
      return;
    }

    setProcessing(true);
    showSnackbar("Processing data...", "info");
    
    // Start progress simulation
    const progressInterval = simulateProgress(4000);

    try {
      const response = await handleStartProcess(batchId);
      
      // Complete progress
      clearInterval(progressInterval);
      setProgress(100);
      
      localStorage.setItem("activeStep", "2");
      setActiveStep(2);
      showSnackbar(
        `Data processed successfully! ${response.rows_processed} records processed.`,
        "success"
      );
    } catch (error) {
      console.error("Process failed:", error);
      clearInterval(progressInterval);
      setProgress(0);
      showErrorDialog(error);
    } finally {
      setProcessing(false);
      setTimeout(() => setProgress(0), 500);
    }
  };

  // ------------------- Download Processed File -------------------
  const onDownloadFile = async () => {
    setUploadKey(prev => prev + 1);

    if (!batchId) {
      showSnackbar("Batch ID missing. Please upload and process a file first.", "warning");
      return;
    }

    setDownloadingFile(true);
    showSnackbar("Downloading file...", "info");
    
    // Start progress simulation
    const progressInterval = simulateProgress(2000);

    try {
      await handleDownloadFile(batchId);

      // Complete progress
      clearInterval(progressInterval);
      setProgress(100);

      // Cleanup after download
      localStorage.removeItem("batchId");
      localStorage.removeItem("activeStep");
      localStorage.removeItem("uploadedFileName");
      setBatchId(null);
      setFileSelected(false);
      setActiveStep(0);
      setUploadedFileName(null);

      showSnackbar("File downloaded successfully!", "success");
    } catch (error) {
      console.error("Download failed:", error);
      clearInterval(progressInterval);
      setProgress(0);
      showErrorDialog(error);
    } finally {
      setDownloadingFile(false);
      setTimeout(() => setProgress(0), 500);
    }
  };

  // ------------------- Download Sample -------------------
  const onDownloadSample = async () => {
    setDownloadingSample(true);
    
    // Start progress simulation
    const progressInterval = simulateProgress(1500);
    
    try {
      await handleDownloadSample();
      
      // Complete progress
      clearInterval(progressInterval);
      setProgress(100);
      
      showSnackbar("Sample file downloaded!", "success");
    } catch (error) {
      clearInterval(progressInterval);
      setProgress(0);
      showSnackbar("Failed to download sample file", "error");
    } finally {
      setDownloadingSample(false);
      setTimeout(() => setProgress(0), 500);
    }
  };

  // Check if any operation is in progress
  const isAnyOperationInProgress = uploadingFile || downloadingSample || processing || downloadingFile;

  // Get current operation status for CLoader
  const getLoaderStatus = () => {
    if (uploadingFile) return "Uploading file to server...";
    if (downloadingSample) return "Preparing sample file...";
    if (processing) return "Processing maintenance planning data...";
    if (downloadingFile) return "Generating output file...";
    return "Processing";
  };

  return (
    <>
      <Toolbar />

      {/* CLoader overlay - shows when any operation is in progress */}
      {isAnyOperationInProgress && (
        <CLoader 
          progress={progress}
          stats={{
            processed: 0,
            total: 0,
            timeElapsed: "0:00",
            timeRemaining: "0:00"
          }}
          status={getLoaderStatus()}
          hideTimeRemaining={uploadingFile || downloadingSample || downloadingFile}
          theme={theme}
        />
      )}

      <Box sx={{ maxWidth: 1100, mx: "auto", mt: 4 }}>
        {/* Stepper */}
        <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <CBox sx={{ p: 3, borderRadius: 2, boxShadow: 2 }}>
          {/* File Info Display */}
          {uploadedFileName && activeStep > 0 && (
            <Alert severity="info" sx={{ mb: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="body2" fontWeight="bold">
                    Current File: {uploadedFileName}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Batch ID: {batchId}
                  </Typography>
                </Box>
                <Button 
                  size="small" 
                  startIcon={<RestartAltIcon />}
                  onClick={() => setConfirmReset(true)}
                  disabled={isAnyOperationInProgress}
                  color="secondary"
                >
                  Start Over
                </Button>
              </Box>
            </Alert>
          )}

          {/* Upload Area */}
          <Box
            sx={{
              border: "2px dashed",
              borderColor: theme.palette.primary.main,
              borderRadius: 2,
              p: 4,
              textAlign: "center",
              mb: 3,
              position: "relative",
              opacity: activeStep > 0 ? 0.5 : 1
            }}
          >
            <CUpload 
              key={uploadKey} 
              modelSelected={true} 
              onFileSelection={onFileUpload} 
              theme={theme}
              disabled={isAnyOperationInProgress || activeStep > 0}
            />
            <Typography variant="caption" color="textSecondary" sx={{ mt: 2, display: "block" }}>
              Supported formats: .xlsx, .xls (Max 10MB)
            </Typography>
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
            <Button
              variant="contained"
              startIcon={downloadingSample ? <CircularProgress size={20} /> : <DownloadIcon />}
              onClick={onDownloadSample}
              disabled={downloadingSample || isAnyOperationInProgress}
              sx={{ minWidth: 180 }}
            >
              {downloadingSample ? "Downloading..." : "Download Sample"}
            </Button>

            <Button
              variant="contained"
              startIcon={processing ? <CircularProgress size={20} /> : <UploadIcon />}
              disabled={!fileSelected || activeStep !== 1 || isAnyOperationInProgress}
              onClick={onStartProcess}
              sx={{ minWidth: 180 }}
            >
              {processing ? "Processing..." : "Start Process"}
            </Button>

            <Button
              variant="contained"
              startIcon={downloadingFile ? <CircularProgress size={20} /> : <DownloadIcon />}
              disabled={!fileSelected || activeStep !== 2 || isAnyOperationInProgress}
              onClick={onDownloadFile}
              sx={{ minWidth: 180 }}
            >
              {downloadingFile ? "Downloading..." : "Download File"}
            </Button>
          </Box>

          {/* Helper Text */}
          <Box sx={{ mt: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary" align="center">
              {activeStep === 0 && "📤 Step 1: Upload your Excel file to begin"}
              {activeStep === 1 && "⚙️ Step 2: Click 'Start Process' to process the uploaded data"}
              {activeStep === 2 && "✅ Step 3: Download the processed results"}
            </Typography>
          </Box>
        </CBox>
      </Box>

      {/* Snackbar for quick notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Reset Confirmation Dialog */}
      <Dialog open={confirmReset} onClose={() => setConfirmReset(false)}>
        <DialogTitle>Start Over?</DialogTitle>
        <DialogContent>
          <Typography>
            This will discard your current progress and uploaded file. Are you sure you want to start over?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmReset(false)}>Cancel</Button>
          <Button onClick={onReset} color="error" variant="contained">
            Yes, Start Over
          </Button>
        </DialogActions>
      </Dialog>

      {/* Error Dialog */}
      <Dialog
        open={errorDialog.open}
        onClose={closeErrorDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ErrorOutlineIcon color="error" />
          {errorDialog.title}
        </DialogTitle>
        
        <DialogContent>
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorDialog.message}
          </Alert>

          {errorDialog.details && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle2" gutterBottom>
                Details:
              </Typography>
              
              {/* Invalid format */}
              {errorDialog.errorType === "invalid_format" && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Your file:</strong> {errorDialog.details.your_file}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Format:</strong> {errorDialog.details.uploaded_format}
                  </Typography>
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                      <strong>Allowed formats:</strong>
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                      {errorDialog.details.allowed_formats?.map((format) => (
                        <Chip 
                          key={format} 
                          label={format} 
                          size="small" 
                          color="primary" 
                          variant="outlined" 
                        />
                      ))}
                    </Box>
                  </Box>
                </Box>
              )}

              {/* Missing columns */}
              {errorDialog.errorType === "missing_columns" && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="error" gutterBottom>
                    <strong>Missing columns:</strong>
                  </Typography>
                  <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
                    {errorDialog.details.missing_columns?.map((col) => (
                      <Chip 
                        key={col} 
                        label={col} 
                        size="small" 
                        color="error" 
                      />
                    ))}
                  </Box>
                </Box>
              )}

              {/* Validation errors */}
              {errorDialog.errorType === "validation_errors" && (
                <Box sx={{ mb: 2 }}>
                  <Alert severity="warning" sx={{ mb: 1 }}>
                    Found {errorDialog.details.total_errors} error(s) in {errorDialog.details.total_rows} rows
                  </Alert>
                  <List dense sx={{ maxHeight: 300, overflow: "auto", bgcolor: "grey.50", p: 1, borderRadius: 1 }}>
                    {errorDialog.details.errors?.map((error, idx) => (
                      <ListItem key={idx} sx={{ py: 0.5 }}>
                        <ListItemText
                          primary={error}
                          primaryTypographyProps={{ 
                            variant: "body2", 
                            color: "error",
                            fontFamily: "monospace"
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                  {errorDialog.details.remaining_errors > 0 && (
                    <Typography 
                      variant="body2" 
                      color="textSecondary" 
                      sx={{ mt: 1, fontStyle: "italic" }}
                    >
                      ... and {errorDialog.details.remaining_errors} more error(s)
                    </Typography>
                  )}
                </Box>
              )}

              {/* File too large */}
              {errorDialog.errorType === "file_too_large" && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="textSecondary">
                    <strong>File size:</strong> {errorDialog.details.file_size}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Maximum allowed:</strong> {errorDialog.details.max_size}
                  </Typography>
                </Box>
              )}
            </Box>
          )}

          {/* Help section */}
          <Alert severity="info" sx={{ mt: 2 }}>
            <AlertTitle>Need Help?</AlertTitle>
            Download the sample file to see the correct format and required columns.
          </Alert>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={onDownloadSample}
            startIcon={<DownloadIcon />}
            variant="outlined"
          >
            Download Sample
          </Button>
          <Button onClick={closeErrorDialog} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Maintenance_planning;